import {Box, styled, Typography} from "@mui/material";
import React from "react";
import AlphaPhaseFireBanner from "./AlphaPhaseFireBanner";
import Brain from "./Brain";
import EarlyAccessCountdown from "./EarlyAccessCountdown";
import LinkButton from "./LinkButton";
import VideoButton from "./VideoButton";



const TopSectionContainer = styled(Box)({
    height: "90vh",
    minHeight: "600px",
    width: "100%",
    position: "relative",
    borderImage: "linear-gradient(90deg, #05080c, #6d7985, #05080c) 100",
    background: "radial-gradient(circle at 50% 0%, #5f6b77 0%,#020508 56%)",
    borderBottom: "2px solid",
    "@media(max-width: 768px)":{
        minHeight: "100vh",
    }
});

const TopSectionTitle = styled(Typography)({
    position: "absolute",
    width: "100%",
    textAlign: "center",
    top: "10vh",
    fontSize: "5rem",
    fontWeight: 600,
    color: "#FFFFFF",
    zIndex: 2,
    textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
    "@media(max-width: 768px)":{
        top: "14vh",
        fontSize: "2rem",
    }
});

const TopSectionUnderTitle = styled(Typography)({
    position: "absolute",
    width: "100%",
    textAlign: "center",
    bottom: "15vh",
    fontSize: "3.5rem",
    fontWeight: 400,
    color: "#FFFFFF",
    zIndex: 2,
    textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
    "@media(max-width: 768px)":{
        fontSize: "1rem",
        top: "45vh",
    }
});

const ButtonContainer = styled(Box)({
    position: "absolute",
    display: "flex",
    gap: "120px",
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
    bottom: "5vh",
    "@media(max-width: 768px)":{
        gap: "20px",
        flexDirection: "column",
        alignItems: "center",
        bottom: "2vh",
    }
});

const TopSectionCountdownContainer = styled(Box)({
    position: "absolute",
    width: "100%",
    top: "-10vh",
    zIndex: 2,
    "@media(max-width: 768px)":{
        top: "-14vh",
    }
});

const TopSection = ():JSX.Element => {
    
    const renderCounter = ():React.ReactNode => {
        if(new Date().getTime() < new Date("2025-09-22T00:00:01Z").getTime()){
            return (<EarlyAccessCountdown
                target="2025-09-22T00:00:01Z"
            />);
        }
        return (
            <AlphaPhaseFireBanner/>
        );
    };
    
    return <TopSectionContainer id={"intro"}>
        <TopSectionTitle variant={"h1"}>
            Lead the AI Revolution in Finance with Us
        </TopSectionTitle>
        <TopSectionCountdownContainer>
            {renderCounter()}
        </TopSectionCountdownContainer>
        <TopSectionUnderTitle variant={"h2"}>
            Harness AI-driven forecasts to transform personal finance and accelerate your growth.
        </TopSectionUnderTitle>
        <Brain/>
        <ButtonContainer>
            <LinkButton title={"Try Technology!"}  externalLink={"https://insight-questor-mvp.web.app/"} />
            <VideoButton title={"Watch Video!"} />
        </ButtonContainer>
    </TopSectionContainer>;
};

export default TopSection;
